import React from 'react';
import ErrorPageCommon, {
  ErrorPageProps,
} from '@lib/components/ErrorPage/ErrorPage';

export default function ErrorPage(props: ErrorPageProps) {
  return <ErrorPageCommon {...props} />;
}
